import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'
import { ChevronDown } from 'lucide-react'
import type { WidgetConfiguration } from '../../types'

interface BasicSettingsSectionProps {
  config: WidgetConfiguration
  onUpdate: (updates: Partial<WidgetConfiguration>) => void
  isOpen: boolean
  onToggle: () => void
}

export function BasicSettingsSection({ config, onUpdate, isOpen, onToggle }: BasicSettingsSectionProps) {
  return (
    <Collapsible open={isOpen} onOpenChange={onToggle}>
      <CollapsibleTrigger className="flex w-full items-center justify-between rounded-lg border p-4 hover:bg-accent">
        <h3 className="font-semibold">Basic Settings</h3>
        <ChevronDown
          className={`h-4 w-4 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </CollapsibleTrigger>
      <CollapsibleContent className="pt-4 space-y-4">
        <div className="space-y-2">
          <Label htmlFor="chat_title">Chat Title</Label>
          <Input
            id="chat_title"
            value={config.chat_title}
            onChange={(e) => onUpdate({ chat_title: e.target.value })}
            placeholder="Assistant"
          />
          <p className="text-xs text-muted-foreground">
            The main title displayed in the chat widget header
          </p>
        </div>

        <div className="space-y-2">
          <Label htmlFor="assistant_name">Assistant Name</Label>
          <Input
            id="assistant_name"
            value={config.assistant_name}
            onChange={(e) => onUpdate({ assistant_name: e.target.value })}
            placeholder="Assistant"
          />
          <p className="text-xs text-muted-foreground">
            The name shown for the assistant in conversations
          </p>
        </div>

        <div className="space-y-2">
          <Label htmlFor="assistant_subtitle">Header Subtitle</Label>
          <Input
            id="assistant_subtitle"
            value={config.assistant_subtitle}
            onChange={(e) => onUpdate({ assistant_subtitle: e.target.value })}
            placeholder="The team can also help"
          />
          <p className="text-xs text-muted-foreground">
            Optional subtitle text shown below the chat title
          </p>
        </div>
      </CollapsibleContent>
    </Collapsible>
  )
}
